import {useContext, useEffect, useState} from "react";
import api from "services/api";
import AdminPromocaoModal from './modal';
import './style.css';
import {formatDate, formatImage, getHoje} from "components/formatos";
import config from 'config';
import PAGINACAO from "components/paginacao";
import {CidadeContext} from "services/cidade";

function AdminPromocoes(){
    const [lpromocoes, setLPromocoes] = useState([]);

    const { cod_cidade } = useContext(CidadeContext)

    // Modal
    const [operacao, setOperacao] = useState('')
    const [dados, setDados] = useState([]);
    const [isOpen, setIsOpen] = useState(false);

    function closeAdminPromocaoModal(){
        setIsOpen(false);
    }

    useEffect(()=>{
        api.get(`${config.ADM_PROMOCOES}?cod_cidade=${cod_cidade}`)
        .then( response => {
            setLPromocoes(response.data);
        });
    },[isOpen, cod_cidade])

    function novoPromocao(){
        setDados(           
            {
                "id_promocao": 0,
                "id_estabelecimento": 0,
                "data_inicio": getHoje(),
                "data_final": getHoje(),
                "ies_pago": 'N',
                "image": "",
                "linkproduto": ""
            } 
        );
        setIsOpen(true);
    }

    function editarPromocao(linha){
        setOperacao('UPDATE')
        setDados(linha);
        setIsOpen(true);
    }

    return (
        <div>
            <AdminPromocaoModal 
                isOpen={isOpen}
                onRequestClose={closeAdminPromocaoModal}                 
                operacao={operacao}
                dados={dados}
            /> 
            
            <div className="admin-header-section mb-4">
                <div className="d-flex justify-content-between align-items-center flex-wrap gap-3">
                    <h2 className="section-title mb-0">Promoções por Estabelecimento</h2>
                    <button 
                        className="btn btn-primary d-flex align-items-center gap-2 px-4 py-2 shadow-sm" 
                        onClick={() => novoPromocao()}
                        style={{ borderRadius: '12px' }}
                    >
                        <i className="fas fa-plus"></i>
                        <span>Nova Promoção</span>
                    </button>
                </div>
            </div>

            <PAGINACAO
                data={lpromocoes}
                itemsPerPage={12}
                renderItems={(currentItems) => (
                    <div className="row g-4">
                        {currentItems.map((e, index) => {
                            const estaAtiva = new Date(e.dat_final) >= new Date(getHoje());
                            return (
                                <div className="col-12 col-md-6 col-lg-4 col-xl-3" key={`prom-${index}`}>
                                    <div className="promocao-admin-card h-100 bg-card-admin rounded-4 overflow-hidden position-relative transition-all" onClick={() => editarPromocao(e)}>
                                        <div className="p-3 border-bottom d-flex align-items-center justify-content-between bg-light-subtle">
                                            <span className="text-muted small fw-bold">ID: #{e.id_promocao}</span>
                                            <span className={`badge ${estaAtiva ? 'bg-success' : 'bg-secondary'}`}>
                                                {estaAtiva ? 'Ativa' : 'Encerrada'}
                                            </span>
                                        </div>
                                        
                                        <div className="promocao-preview-container bg-light" style={{ height: '140px' }}>
                                            {formatImage(e.imagem) ? (
                                                <img src={formatImage(e.imagem)} alt="Promoção" className="w-100 h-100 object-fit-cover" />
                                            ) : (
                                                <div className="d-flex align-items-center justify-content-center h-100 text-muted opacity-25">
                                                    <i className="fas fa-tag fa-3x"></i>
                                                </div>
                                            )}
                                        </div>

                                        <div className="p-4">
                                            <div className="text-primary small fw-bold mb-1" style={{fontSize: '0.7rem'}}>Estabelecimento</div>
                                            <h5 className="promocao-estab-name mb-3 text-truncate" title={e.nomeestabelecimento}>
                                                {e.nomeestabelecimento}
                                            </h5>
                                            
                                            <div className="promocao-admin-dates">
                                                <div className="d-flex align-items-center text-muted small mb-1">
                                                    <i className="far fa-calendar-alt me-2"></i>
                                                    <span>Início: <strong>{formatDate(e.dat_inicio)}</strong></span>
                                                </div>
                                                <div className="d-flex align-items-center text-muted small">
                                                    <i className="fas fa-calendar-check me-2"></i>
                                                    <span>Fim: <strong>{formatDate(e.dat_final)}</strong></span>
                                                </div>
                                            </div>
                                        </div>
                                        
                                        <div className="p-3 border-top bg-light-subtle d-flex justify-content-center">
                                            <button className="btn btn-outline-primary btn-sm rounded-3 px-4 w-100">
                                                <i className="fas fa-edit me-1"></i> Editar Promoção
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                )}
            />
        </div>
    );
}

export default AdminPromocoes;